import ReactDOM from "react-dom";
import React from "react";
import * as _ from "lodash";

import * as SmartDrawings from "../../smartDrawings";
import { viewerOptions } from "../../viewer";

type BuildOrderCallback = (buildOrder: SmartDrawings.BuildOrder) => void;

interface BuildOrderListProps {
    buildOrders: SmartDrawings.BuildOrder[];
    setBuildOrder: BuildOrderCallback; 
}

interface BuildOrderListState {
    selectedOrder?: SmartDrawings.BuildOrder;
}

interface BuildOrderRowProps {
    buildOrder: SmartDrawings.BuildOrder;
    selected: boolean;
    onSelect: () => void;
}

const BuildOrderRow: React.SFC<BuildOrderRowProps> = (props) => {
    return <li className="color-item" onClick={props.onSelect} style={props.selected ? {backgroundColor : "blue"}: null}><div className="color-label">{props.buildOrder.name}</div></li>;
}

class BuildOrderList extends React.Component<BuildOrderListProps, BuildOrderListState> {

    constructor(props) {
        super(props);
        this.state = {
            selectedOrder: props.buildOrders[0]
        }
    }

    onSelectBuildOrder = (buildOrder) => {
        this.setState({ selectedOrder: buildOrder });
        this.props.setBuildOrder(buildOrder);
    }

    render() {
        return (
            <div className="react-content">
                <ul className="plain-list">
                    {this.props.buildOrders.map(bo => <BuildOrderRow key={bo.name} buildOrder={bo} selected={this.state.selectedOrder === bo} onSelect={() => this.onSelectBuildOrder(bo)}/>)}
                </ul>
            </div>
        );
    }
}
export class BuildOrderPanel extends Autodesk.Viewing.UI.DockingPanel {

    private viewer: Autodesk.Viewing.GuiViewer3D;

    private contentDiv: HTMLDivElement;
    private reactNode;
    private setBuildOrder: BuildOrderCallback;
   
    constructor(viewer: Autodesk.Viewing.GuiViewer3D, container: any, setBuildOrder: BuildOrderCallback) {
        super(container, "SmartDrawings-Panel-BuildOrder", "Build orders");
        this.viewer = viewer;
        this.setBuildOrder = setBuildOrder;
        this.container.classList.add("color-legend-panel");

        this.contentDiv = document.createElement("div");
        this.contentDiv.classList.add("content");
        this.container.appendChild(this.contentDiv);
    }

    setVisible(show: boolean) {
        super.setVisible(show);
        if (show) {
            ReactDOM.unmountComponentAtNode(this.contentDiv);
            this.reactNode = ReactDOM.render(<BuildOrderList buildOrders={viewerOptions.buildOrders} setBuildOrder={this.setBuildOrder} />, this.contentDiv);
        } else if (this.reactNode) {
            ReactDOM.unmountComponentAtNode(this.contentDiv);
            this.reactNode = null;
        }
    }
}



